// if (window.location.pathname.includes('/customise')) {
//   let allProducts = [];
//   let productsLoaded = false;
//   let hasProcessed = false;

//   const normalizeString = (str) => str.toLowerCase().trim().replace(/\s+/g, ' ');

//   const waitForProducts = () => {
//     return new Promise((resolve, reject) => {
//       if (productsLoaded) resolve();
//       const checkInterval = setInterval(() => { if (productsLoaded) { clearInterval(checkInterval); resolve(); } }, 100);
//       setTimeout(() => { clearInterval(checkInterval); reject(new Error('Products loading timeout')); }, 10000);
//     });
//   };

//   fetch('/products.json')
//     .then(res => { if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`); return res.json(); })
//     .then(data => { allProducts = data.products; productsLoaded = true; })
//     .catch(err => console.error('[Customizer] Failed to fetch products:', err));

//   window.addEventListener('message', async (event) => {
//     const shopifyData = event.data?.shopify;
//     if (!shopifyData || shopifyData.action !== 'addToCart2' || !Array.isArray(shopifyData.payload) || hasProcessed) return;

//     try {
//       await waitForProducts();
//     } catch (err) {
//       console.error('[Customizer] Products not loaded:', err);
//       return;
//     }

//     hasProcessed = true;

//     const payload = shopifyData.payload; // This contains ALL selections
//     const productTitle = shopifyData.productInfo?.title || 'Tipi Tap';

//     // Normalize the product title from configurator
//     const productTitleNorm = normalizeString(productTitle);
    
//     // Find the product by matching the title
//     const product = allProducts.find(p => normalizeString(p.title) === productTitleNorm);

//     if (!product) {
//       console.warn(`[Customizer] Product not found: "${productTitleNorm}"`);
//       return;
//     }

//     // Dynamic variant matching based on product structure
//     const matchedVariant = findMatchingVariant(product, payload, productTitleNorm);

//     if (!matchedVariant) {
//       // console.warn(`[Customizer] Variant not found for product: ${productTitleNorm}`);
//       // console.log('[Customizer] Available variants:', product.variants);
//       return;
//     }

//     if (!matchedVariant.available) {
//       console.warn(`[Customizer] Variant "${matchedVariant.title}" is not available`);
//       return;
//     }
//     // Create cart properties from all selections, but remove duplicates that Shopify will add automatically
//     const cartProperties = {};
    
//     // First, add all selections from payload
//     payload.forEach(selection => {
//       const key = Object.keys(selection)[0];
//       const value = selection[key];
//       cartProperties[key] = value;
//     });

//     // Remove core variant options that Shopify will add automatically to prevent duplicates
//     const coreOptionNames = ['Colour of the Teepee', 'Mattress Option'];
//     coreOptionNames.forEach(optionName => {
//       if (cartProperties[optionName]) {
//         delete cartProperties[optionName];
//         // console.log(`[Customizer] Removed duplicate property: ${optionName}`);
//       }
//     });

//     // console.log(`[Customizer] Final cart properties:`, cartProperties);

//     const cartItems = [{
//       id: matchedVariant.id,
//       quantity: 1,
//       properties: cartProperties // Clean properties without duplicates
//     }];

//     try {
//       const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js';
//       const response = await fetch(cartUrl, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ items: cartItems })
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         if (result.message) throw new Error(`Shopify Error: ${result.message}`);
//         else if (result.description) throw new Error(`Shopify Error: ${result.description}`);
//         else throw new Error(`HTTP ${response.status}: Add to cart request failed`);
//       }

//       // console.log('[Customizer] Successfully added to cart:', result);

//       const cartRedirectUrl = window.routes?.cart_url || '/cart';
//       window.location.href = cartRedirectUrl;

//     } catch (err) {
//       console.error('[Customizer] Error adding to cart:', err);
//       alert(`Failed to add items to cart: ${err.message}`);
//     } finally {
//       hasProcessed = false;
//     }
//   });

//   // Flexible variant matching function
//   function findMatchingVariant(product, payload, productTitle) {
//     // For Tipi Tap products
//     if (productTitle.includes('tipi') || productTitle.includes('teepee')) {
//       const teepeeColor = payload.find(item => item['Colour of the Teepee'])?.['Colour of the Teepee'];
//       const mattressOpt = payload.find(item => item['Mattress Option'])?.['Mattress Option'];
      
//       if (!teepeeColor || !mattressOpt) {
//         console.warn('[Customizer] Missing required options for teepee:', { teepeeColor, mattressOpt });
//         return null;
//       }

//       return product.variants.find(variant => {
//         const vOpt1 = normalizeString(variant.option1 || '');
//         const vOpt2 = normalizeString(variant.option2 || '');
//         return vOpt1 === normalizeString(teepeeColor) && vOpt2 === normalizeString(mattressOpt);
//       });
//     }
    
//     // If no specific logic matches, return the first available variant
//     if (product.variants.length > 0) {
//       // console.log('[Customizer] No specific variant matching logic found, using first variant');
//       return product.variants[0];
//     }
    
//     return null;
//   }
// }



// if (window.location.pathname.includes("/customise")) {
//   // console.log("Entering customizer script...");

//   let hasProcessed = false;

//   window.addEventListener("message", async (event) => {
//     const shopifyData = event.data?.shopify;

//     if (
//       !shopifyData ||
//       shopifyData.action !== "addToCart2" ||
//       typeof shopifyData.payload !== "object" ||
//       shopifyData.payload === null ||
//       Array.isArray(shopifyData.payload) ||
//       hasProcessed
//     ) {
//       return;
//     }

//     // console.log("Received Shopify data:", shopifyData);
//     hasProcessed = true;

//     try {
//       const product = window.configuratorProduct;

//       if (!product) {
//         throw new Error("Configurator product not found.");
//       }

//       if (!product.variants?.length) {
//         throw new Error("Product has no variants.");
//       }

//       const variant = product.variants[0];

//       if (!variant) {
//         throw new Error("Configurator product is unavailable.");
//       }

//       // Payload is already an object
//       const properties = {
//         ...shopifyData.payload
//       };
//       // console.log("Cart properties:", properties);
//       delete properties["tone type"];
//       delete properties["mattress tone type"];

//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "X-Requested-With": "XMLHttpRequest",
//         },
//         body: JSON.stringify({
//           items: [
//             {
//               id: variant.id,
//               quantity: 1,
//               properties,
//             },
//           ],
//         }),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(
//           result.description ||
//           result.message ||
//           "Failed to add product to cart."
//         );
//       }

//       // console.log("Added to cart:", result);

//       window.location.href = "/cart";
//     } catch (err) {
//       console.error("[Customizer]", err);
//       alert(err.message);
//     } finally {
//       hasProcessed = false;
//     }
//   });
// }





if (window.location.pathname.includes("/customise")) {
  console.log("Entering customizer script...");

  let hasProcessed = false;

  window.addEventListener("message", async (event) => {
    const shopifyData = event.data?.shopify;

    if (
      !shopifyData ||
      shopifyData.action !== "addToCart2" ||
      typeof shopifyData.payload !== "object" ||
      shopifyData.payload === null ||
      Array.isArray(shopifyData.payload) ||
      hasProcessed
    ) {
      return;
    }

    // console.log("Received Shopify data:", shopifyData);
    hasProcessed = true;

    try {
      const product = window.configuratorProduct;

      if (!product) {
        throw new Error("Configurator product not found.");
      }

      if (!product.variants?.length) {
        throw new Error("Product has no variants.");
      }
      // Payload is already an object
      const properties = {
        ...shopifyData.payload
      };

      let variant = null;

      if ("additional options" in properties) {
        variant = product.variants[1];
        const personalizationNameKey = properties["additional options"]
        properties['personalized name'] = personalizationNameKey
        delete properties["additional options"];
      } else {
        variant = product.variants[0];
      }

      if (!variant) {
        throw new Error("Configurator product is unavailable.");
      }

      
      // console.log("Cart properties:", properties);
      delete properties["tone type"];
      delete properties["mattress tone type"];

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [
            {
              id: variant.id,
              quantity: 1,
              properties,
            },
          ],
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          "Failed to add product to cart."
        );
      }

      // console.log("Added to cart:", result);

      window.location.href = "/cart";
    } catch (err) {
      console.error("[Customizer]", err);
      alert(err.message);
    } finally {
      hasProcessed = false;
    }
  });
}